import React, { Component } from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import { createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import DeleteModel from "components/Common/FevoModels/DeleteModel";
import { connect } from "react-redux";
import ReactTable from "react-table";
import toastr from "toastr";
import axios from "../../../config/axios";
import loaderIcon from "assets/img/loader.gif";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Switch from "@material-ui/core/Switch";
import green from "@material-ui/core/colors/green";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment";
const formStyle = {
  minWidth: 300,
  margin: "0 1.2rem 1.2rem 0",
};

class Coupons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmModal: false,
      userTobeChangedIndex: null,
      userTobeChange: null,
      CouponList: [],
      limit: 500,
      offset: 0,
      showCancelModal: false,
      webinarTobeDeleted: "",
      search_event: "",
      status_category: "",
      data: null,
      statusList: [
        "SCHEDULED",
        "BOOKING_STARTED",
        "ONGOING",
        "COMPLETED",
        "ADMIN_CANCELLED",
        "USER_CANCELLED",
      ],
      loading: false,
      webinarTobeDeleted: null,
      userTobeChange: null,
      userTobeChangedIndex: null,
      showBlockUserModal: false,
      popText: "Block",
      eventTobeDeleted: null,
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    axios
      .get(`events/eventcoupans`)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          this.setState({
            CouponList: res.data.data,
            loading: false,
            data: res.data.data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          toastr.error(error.response.data.message);
        } else {
          this.setState({
            loading: false,
          });
        }
      });
  }

  editEventFunc = (event) => {
    this.props.history.push("/admin/manageevents/eventdetail", {
      event,
    });
  };

  reset = () => {
    this.setState({
      status_category: "",
      search_event: "",
      CouponList: this.props.eventListData.data,
    });
  };

  getUserTableColumn = () => {
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let column = [
      {
        Header: "Event Type",
        accessor: "event_type",
      },
      {
        Header: "Event Name",
        accessor: "event_name",
      },
      {
        Header: "User Name",
        accessor: "user_name",
      },
      {
        Header: "Coupon Code",
        accessor: "coupan_code_number",
      },
      {
        Header: "Expiry Date",
        accessor: "expiry_date",
        Cell: (props) => {
          return (
            props.original &&
            props.original.expiry_date &&
            moment(props.original.expiry_date).format("DD MMM YYYY, h:mm a")
          );
        },
      },
      {
        Header: "Action",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: (coupon) => {
          return (
            <div className="actions-center">
              <Tooltip title="View">
                <IconButton
                  color="primary"
                  // className={classes.button}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.history.push("/admin/managecoupon/editcoupon", {
                      event: coupon.original,
                      action: "edit",
                      fieldsDisabled: false,
                    });
                  }}
                >
                  <Icon>visibility_icon</Icon>
                </IconButton>
              </Tooltip>

              <Tooltip title="Copy Coupon">
                <IconButton
                  color="primary"
                  // className={classes.button}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.history.push("/admin/managecoupon/editcoupon", {
                      action: "edit",
                      event: coupon.original,
                    });
                  }}
                >
                  <Icon>content_copy</Icon>
                </IconButton>
              </Tooltip>

              <Tooltip title="Cancel">
                <IconButton
                  color="primary"
                  // className={classes.button}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({
                      showCancelModal: true,
                      eventTobeDeleted: coupon.original.id,
                    });
                  }}
                >
                  <Icon>cancel_icon</Icon>
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
    ];
    return column;
  };

  handleUserStatusChange = (userTobeChange, userTobeChangedIndex) => {
    let popText;
    if (userTobeChange.active) {
      popText = "Are you sure you want to cancel this VIP seat?";
    } else {
      popText = "Are you sure you want to approve this VIP seat?";
    }
    this.setState({
      userTobeChange,
      userTobeChangedIndex,
      showBlockUserModal: true,
      popText,
    });
  };

  handleBlockModal = () => {
    this.setState(({ showBlockUserModal }) => ({
      showBlockUserModal: !showBlockUserModal,
      userTobeChangedIndex: null,
      userTobeChange: null,
    }));
  };

  changeUserStatus = (user, index) => {
    // const body = { active: !user.active };
    this.setState({
      loading: true,
    });
    let check;
    if (user.active) {
      check = "cancel";
    } else {
      check = "approve";
    }
    axios
      .put(
        `zoom/updateBasicVIPWebinar?webinar_id=${user.id}&action=${check}&registrant_id=${user.registrant_id}&email=${user.email}`
      )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (user.active) {
            toastr.success("VIP Seat Cancelled Successfully!");
            this.handleBlockModal();
            setTimeout(function() {
              window.location.reload();
            }, 2000);
          } else {
            toastr.success("VIP Seat Approved Successfully!");
            this.handleBlockModal();
            setTimeout(function() {
              window.location.reload();
            }, 2000);
          }
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        // debugger;

        toastr.error(error.response.data.message);
        this.handleBlockModal();
      });
  };

  render() {
    const {
      CouponList,
      popText,
      // userTobeChange,
      showBlockUserModal,
      // userTobeChangedIndex,
      loading,
      search_event,
      data,
      showCancelModal,
    } = this.state;
    // const { classes } = this.props;

    // console.log("vav", this.state.CouponList);
    return (
      <div>
        {loading ? (
          <div className="loader_icon">
            <img src={loaderIcon} alt="loader" />
          </div>
        ) : (
          <div>
            <GridContainer>
              <GridItem xs={12}>
                <Card>
                  <CardBody className="table_space vip_list">
                    <FormControl style={formStyle}>
                      <TextField
                        id="standard-search"
                        label="Search Coupon by Event Name"
                        name="search_event"
                        type="search"
                        fullWidth
                        value={search_event}
                        onChange={(event) => {
                          const { value } = event.target;
                          this.setState(
                            {
                              CouponList: data,
                            },
                            () => {
                              const newCouponList = this.state.CouponList.filter(
                                (item) =>
                                  item.event_name
                                    .toLowerCase()
                                    .includes(value.toLowerCase())
                              );
                              this.setState({
                                CouponList: newCouponList,
                                search_event: value.toLowerCase(),
                              });
                            }
                          );
                        }}
                        margin="normal"
                      />
                    </FormControl>

                    <ReactTable
                      data={CouponList || []}
                      loading={loading}
                      columns={this.getUserTableColumn()}
                      defaultPageSize={25}
                      pageSizeOptions={[25, 50, 100]}
                      showPaginationBottom={true}
                      minRows={0}
                      noDataText="No Coupons found!"
                      getTheadThProps={(state, rowInfo, column, instance) => {
                        return {
                          style: {
                            marginBottom: "13px",
                          },
                        };
                      }}
                    />
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
            <DeleteModel
              showModel={showCancelModal}
              title={"Are you sure you want to delete the coupon?"}
              onCancel={() => {
                this.setState({
                  showCancelModal: false,
                });
              }}
              onOk={() => {
                const { eventTobeDeleted } = this.state;

                // let body = {
                //     status: "ADMIN_CANCELLED",
                //     cancellation_reason: "Cancel by Admin"
                // };
                axios
                  .post(`events/deleteCoupanById/${eventTobeDeleted}`)
                  .then((res) => {
                    if (res.status === 200 || res.status === 201) {
                      toastr.success("Coupon Deleted Successfully!");
                      this.setState({
                        showCancelModal: false,
                      });
                    }
                  })
                  .catch((error) => {
                    toastr.error(error.response.data.message);
                    this.setState({
                      showCancelModal: false,
                    });
                  });
                // events/:event-id/status
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

const CouponsListComponent = withStyles(extendedTablesStyle)(Coupons);
export default connect()(CouponsListComponent);



// WEBPACK FOOTER //
// ./src/views/ISEAS/coupon/index.js